import { schema } from 'normalizr';
import {
  entitiesSelectorList,
  entitiesSelectorItem,
} from '../utils/asyncHelpers';

const schemaEntity = new schema.Entity('legalEntityDocument');

export const getLegalEntityDocuments = entitiesSelectorList(schemaEntity);
export const getlegalEntityDocument = entitiesSelectorItem(schemaEntity);
export default schemaEntity;
